module.exports = __webpack_public_path__ + "static/media/western-bulldogs-logo.2e95a463.svg";